import React, { useEffect, useRef, useState } from "react";

import { FormHelperText, Grid, Tab, Tabs, tabsClasses } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Notification from "../../../../components/Common/Notification";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import CustomButton from "../../../../components/Form/CustomButton";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import "../../setting.css"
import TablePageControl from "../../../../components/Common/TablePageControl";
import Table from "../../../../components/Common/Table";
import CustomSelect2 from "../../../../components/Form/CustomSelect2";
import SearchBar from "../../../../components/Common/Searchbar";
import AppDialog from "../../../../components/Common/AppDialog";
import CustomTextField from "../../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../../components/Form/RadioButtonGroup";
import CustomSelect from "../../../../components/Form/CustomSelect";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import Label from "../../../../components/Common/Label";
import { createModel, deleteModel, exportModel, getGeneral, getModelListing, resetModelAttachmentState, resetModelState, updateModel } from "../../../../store/actions";
import Helpers from "../../../../helpers/helpers";
import RenderPopOverButton from "../../../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../../../components/Common/DeleteModal.js";


const ProductModelSetting = ({ title, categoryListing, modelListing, manufacturerListing, addModel, editModel, deleteModelItem, formError, exportModelDocument, userPermission }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetModelState());
    }, [])

    const [loading, setIsLoading] = useState(false);
    const [values, setFormValues] = useState({ category: '' });
    const [filterStatus, setFilterStatus] = useState("all");
    const [selectedRow, setSelectedRow] = useState();
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [checkedAll, setCheckedAll] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState("id");
    const [error, setError] = useState();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    const data = [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]

    const header = [
        {
            Header: "Models",
            columnID: "id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps.model_name}</div>
                    </React.Fragment>
                )
            },
            minWidth: 300,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Manufacturer",
            columnID: "manufacturer_name",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.manufacturer_name || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Category",
            columnID: "category_name",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.category_name || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel label={cellProps?.status === 1 ? 'active' : 'inactive'} marginLeft={"0px"} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <CustomIconButton
                            iconName={'ri-pencil-line'}
                            onClick={() => { setSelectedRow(cellProps); setEditModalOpen(true); setError() }}
                        />}
                        <RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#44d62c',
                                permission: deletable,
                                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                            }]}
                        />
                    </React.Fragment>
                )
            },
            minWidth: 80,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
            minWidth: 120
        }
    ]

    useEffect(() => {
        initData();
    }, [sort, sort_by, page, length, filterStatus, tabValue, sort])

    useEffect(() => {
        if (formError?.length > 0) {
            setError(formError[0]);
            setIsLoading(false);
        }
    }, [formError])

    useEffect(() => {
        if (exportModelDocument?.code === 'success' && exportModelDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(exportModelDocument.excel_base64, 'model_listing');
            dispatch(resetModelAttachmentState());
        }
        setIsLoading(false);
    }, [exportModelDocument])

    useEffect(() => {
        if (formError?.length > 0) {
            setError(formError[0]);
        } else {
            setError();
        }
        setIsLoading(false);
    }, [formError])

    useEffect(() => {
        if (addModel?.code === 'success') {
            setAddModalOpen(false);
            resetValues();
            setNotification({
                open: true,
                msg: 'Model added successfully',
                type: 'success'
            })
            dispatch(getGeneral());
            dispatch(resetModelState());
            initData();
        }
        setIsLoading(false);
    }, [addModel])

    useEffect(() => {
        if (editModel?.code === 'success') {
            setEditModalOpen(false);
            setNotification({
                open: true,
                msg: 'Model updated successfully',
                type: 'success'
            })
            dispatch(getGeneral());
            dispatch(resetModelState());
            initData();
        }
        setIsLoading(false);
    }, [editModel])

    useEffect(() => {
        if (deleteModelItem?.code === "success") {
            setDeleteOpen(false);
            setNotification({ open: true, msg: "Model deleted successfully", type: "success" });
            dispatch(resetModelState());
            dispatch(getGeneral());
            setPage("1");
            initData();
        }
        setIsLoading(false);
    }, [deleteModelItem])

    const initData = () => {
        let payload = {
            paginate: page,
            sort: sort_by,
            sort_order: sort,
            size: length,
            search: searchRef.current,
            filterStatus: filterStatus === 'all' ? '' : filterStatus,
            filterCategory: tabValue === 0 ? '' : categoryListing[tabValue - 1]?.id
        }
        dispatch(getModelListing(payload));
    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus(filterStatus === '' ? 'all' : '');
    }

    const resetValues = () => {
        setFormValues({
            model_name: '',
            manufacturer: '',
            category: '',
        })
    }

    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleSubmitNewModel = () => {
        let payload = {
            name: values?.model_name,
            category_id: values?.category,
            manufacturer_id: values?.manufacturer,
        }
        dispatch(createModel(payload));
        setIsLoading(true);
    }

    const handleSubmitEditModel = () => {
        let payload = {
            name: selectedRow?.model_name,
            category_id: selectedRow?.category_id,
            manufacturer_id: selectedRow?.manufacturer_id,
            status: selectedRow?.status,
        }
        dispatch(updateModel({ id: selectedRow?.id, data: payload }));
        setIsLoading(true);
    }

    const handleDelete = () => {
        if (selectedRow?.id) {
            setIsLoading(true);
            dispatch(deleteModel({ id: selectedRow.id }));
        }
    }

    const handleExport = () => {
        let filter = {
            status: filterStatus,
            search: keyword,
        };
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportModel({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
    }

    const addManufacturerModal = () => {
        return (
            <AppDialog
                titleIcon={'add'}
                title={'Add Model'}
                open={addModalOpen}
                close={() => setAddModalOpen(false)}
                positiveTitle={'Save'}
                positivePress={() => handleSubmitNewModel()}
                negativeTitle={'Cancel'}
                negativePress={() => setAddModalOpen(false)}
                width={'40%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Model name'}
                            values={values?.model_name}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                model_name: e
                            }))}
                            placeholder="Model name"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomSelect
                            title={'Manufacturer'}
                            values={values?.manufacturer || '-1'}
                            data={manufacturerListing || []}
                            valueName={'id'}
                            labelName={'name'}
                            placeholder={'Please select'}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                manufacturer: e
                            }))}
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.manufacturer_id || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomSelect
                            title={'Category'}
                            values={values?.category || '-1'}
                            data={categoryListing || []}
                            valueName={'id'}
                            labelName={'name'}
                            placeholder={'Please select'}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                category: e
                            }))}
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.category_id || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const editManufacturerModal = () => {
        return (
            <AppDialog
                titleIcon={'edit'}
                title={'Edit Model'}
                open={editModalOpen}
                close={() => setEditModalOpen(false)}
                positiveTitle={'Save Changes'}
                positivePress={() => handleSubmitEditModel()}
                negativeTitle={'Cancel'}
                negativePress={() => setEditModalOpen(false)}
                width={'40%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Model name'}
                            values={selectedRow?.model_name}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                model_name: e
                            }))}
                            placeholder="Model name"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.model_name || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomSelect
                            title={'Manufacturer'}
                            values={selectedRow?.manufacturer_id || '-1'}
                            data={manufacturerListing || []}
                            valueName={'id'}
                            labelName={'name'}
                            placeholder={'Please select'}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                manufacturer_id: e
                            }))}
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.manufacturer_id || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomSelect
                            title={'Category'}
                            values={selectedRow?.category_id || '-1'}
                            data={categoryListing || []}
                            valueName={'id'}
                            labelName={'name'}
                            placeholder={'Select one'}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                category_id: e
                            }))}
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.category_id || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <RadioButtonGroup
                            title={'Status'}
                            value={selectedRow?.status}
                            data={data}
                            setValue={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                status: e,
                            }))}
                            required="true"
                            name="status"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const CustomTabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <div className="mt-1">{children}</div>}
            </div>
        );
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={12} md={10} lg={10} className="d-flex align-items-center" spacing={1}>
                    <Grid item lg={4} md={4} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12}>
                        <CustomSelect2 values={filterStatus || 'all'} onChange={(e) => { setPage("1"); setFilterStatus(e || '') }} data={Helpers.status} placeholder={'All statuses'} />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item xs={12} sm={12} md={2} lg={2} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !modelListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {creatable && <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Model</>}
                            press={() => setAddModalOpen(true)}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />}
                    </Breadcrumb>
                    {customToolsBar()}
                    <div>
                        <Tabs
                            value={tabValue}
                            scrollButtons={true}
                            variant="scrollable"
                            onChange={(e, val) => setTabValue(val)}
                            aria-label="basic tabs example"
                            TabIndicatorProps={{ style: { backgroundColor: 'var(--bs-theme-color)' } }} sx={{
                                [`& .${tabsClasses.scrollButtons}`]: {
                                    '&.Mui-disabled': { opacity: 0.3 },
                                },
                            }}
                        >
                            <Tab label={<div className="d-flex" style={{ color: tabValue === 0 ? '#282828' : '#A0A0A0' }}>All categories<div className="setting-desc2 mx-2">{tabValue === 0 && (modelListing?.data?.length || 0)}</div></div>} {...a11yProps(0)} />
                            {
                                categoryListing?.length > 0 && categoryListing.map((category, index) => {
                                    return (
                                        <Tab
                                            label={
                                                <div className="d-flex" style={{ color: tabValue === index + 1 ? '#282828' : '#A0A0A0' }}>
                                                    {category?.name}
                                                    <div className="setting-desc2 mx-2">{tabValue === index + 1 && (modelListing?.data?.length || 0)}</div></div>
                                            }
                                            {...a11yProps(index + 1)}
                                        />
                                    )
                                })
                            }
                        </Tabs>
                    </div>
                    <CustomTabPanel value={tabValue} index={tabValue}>
                        <Table
                            header={header}
                            data={modelListing?.data || []}
                            pageSize={length}
                            totalPage={modelListing?.last_page || 1}
                            customToolsBar={true}
                            sort={sort}
                            setSorted={setSorted}
                            sort_by={sort_by}
                            setSortBy={setSortBy}
                            setCheckedAll={setCheckedAll}
                            checkedAll={checkedAll}
                        />
                    </CustomTabPanel>

                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={modelListing?.last_page || 1}
                    />
                    {addManufacturerModal()}
                    {editManufacturerModal()}
                    <DeleteModal
                        open={deleteOpen}
                        close={() => setDeleteOpen(false)}
                        submit={() => handleDelete()}
                        module={'model'}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, Model, Login }) {
    return {
        categoryListing: General.categories,
        modelListing: Model.modelListing.data,
        manufacturerListing: General.manufacturers,
        addModel: Model.addModel,
        editModel: Model.updateModel,
        deleteModelItem: Model.deleteModel,
        formError: Model.error,
        exportModelDocument: Model.exportModel,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(ProductModelSetting);
